import {Injectable} from '@angular/core';
import {AuthService} from 'src/app/services/auth/auth.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ErrorPageService {

  tenant: string;

  constructor(private authService: AuthService, private router: Router) {
    this.tenant = this.authService.principal.provider;
  }

  show404Page(): void {
    const tenantText = window.location.href.split('/')[4];
    if (tenantText === 'tenant') {
      this.router.navigate(['/', this.tenant, tenantText, 'error', '404'], {skipLocationChange: true});
    } else {
      this.router.navigate(['/', this.tenant, 'error', '404'], {skipLocationChange: true});
    }
  }
}
